import React from 'react'
import { View, Text } from '@react-pdf/renderer'
import { styles } from '../styles'
import { PDFFooterProps } from '../types'
import { QRCode } from './QRCode'

export function PDFFooter({ 
  compact = false, 
  generatedDate,
  profileName = 'default calibration profile',
  shareUrl
}: PDFFooterProps) {
  const currentDate = generatedDate || new Date().toLocaleDateString()
  
  if (compact) {
    // Minimal footer for compact cards
    return null
  }
  
  return (
    <View style={styles.footer}>
      <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
        <View>
          <Text>Generated by UltraPlan on {currentDate}</Text>
          <Text>Using {profileName}</Text>
          {shareUrl && (
            <Text style={{ fontSize: 8, marginTop: 4 }}>
              View online: {shareUrl}
            </Text>
          )}
        </View>
        {shareUrl && (
          <View style={{ marginLeft: 20 }}>
            <QRCode value={shareUrl} size={60} />
          </View>
        )}
      </View>
    </View>
  )
}